import { render } from "./TaskSchedules.vue?vue&type=template&id=1a4cc1aa&scoped=true"
import script from "./TaskSchedules.vue?vue&type=script&lang=js"
export * from "./TaskSchedules.vue?vue&type=script&lang=js"

import "./TaskSchedules.vue?vue&type=style&index=0&id=1a4cc1aa&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4cc1aa"]])

export default __exports__